// src/components/QuestionRenderer/index.js
// 役割：設問のタイプに応じて表示コンポーネントを切り替える。
// - mode = 'practice' のとき：練習用 UI（JournalEntryQuestion）
// - mode = 'test'     のとき：試験用 UI（TestQuestionInterface）
// ※ UI文言・コメントは日本語で記述

import React from 'react';
import JournalEntryQuestion from '../QuestionTypes/JournalEntryQuestion';
import TestQuestionInterface from '../QuestionTypes/TestQuestionInterface';

const QuestionRenderer = ({ mode = 'practice', ...props }) => {
  const { question } = props;

  // 設問データがまだ届いていない場合の表示
  if (!question) return <div>設問を読み込み中...</div>;

  // 設問タイプごとにレンダリングを分岐
  switch (question.type) {
    case 'JOURNAL_ENTRY':
      // 試験モード：試験専用インタフェース
      if (mode === 'test') {
        return <TestQuestionInterface {...props} />;
      }
      // 練習モード：通常の仕訳入力コンポーネント
      return <JournalEntryQuestion {...props} />;

    // 未対応タイプ
    default:
      return <div>エラー：未対応の設問タイプです。</div>;
  }
};

export default QuestionRenderer;
